import React, { useEffect, useState } from 'react'
import { Alert, Button, Col, Container, Row, Spinner } from 'react-bootstrap'
import isAuthenticated from '../../../routes/PrivateRoute'
import PropTypes from 'prop-types'
import AddActionModal from '../../Modals/AddActionModal'
import UpdateRuleModal from '../../Modals/UpdateRuleModal'

const Rules = ({ rules, getRulesState, addRuleAction, addRuleActionState, deleteRuleAction, deleteRuleActionState, actions, updateRule, updateRuleState, reset }) => {
  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'info',
    message: ''
  })

  const [showActionModal, setShowActionModal] = useState(false)
  const [showRuleModal, setShowRuleModal] = useState(false)
  const [rule, setRule] = useState({})
  const [opportunity, setOpportunity] = useState({})

  const handleCloseModal = () => {
    setShowActionModal(false)
  }

  const handleOpenModal = (opportunity, rule) => {
    setOpportunity(opportunity)
    setRule(rule)
    setShowActionModal(true)
  }

  const handleSubmit = (values) => {
    addRuleAction(opportunity.opportunityId, rule.ruleId, values.selector[0].actionId)
  }

  const handleOpenRuleModal = (opportunity, rule) => {
    setOpportunity(opportunity)
    setRule(rule)
    setShowRuleModal(true)
  }

  const handleCloseRuleModal = () => {
    setShowRuleModal(false)
  }

  const handleSubmitUpdateRule = () => {
    updateRule(opportunity.opportunityId, rule)
  }

  useEffect(() => {
    setAlertState({
      show: false,
      variant: 'info',
      message: ''
    })
    return () => reset()
  }, [])

  useEffect(() => {
    if (deleteRuleActionState.success) {
      setAlertState({
        show: true,
        variant: 'success',
        message: 'Removed action from rule.'
      })
    }

    if (deleteRuleActionState.error !== false) {
      setAlertState({
        show: true,
        variant: 'danger',
        message: deleteRuleActionState.error.message
      })
    }
  }, [deleteRuleActionState.success, deleteRuleActionState.error])

  useEffect(() => {
    if (addRuleActionState.success) {
      setAlertState({
        show: true,
        variant: 'success',
        message: 'Added action to rule.'
      })

      setShowActionModal(false)
    }
  }, [addRuleActionState.success])

  useEffect(() => {
    if (updateRuleState.success) {
      setAlertState({
        show: true,
        variant: 'success',
        message: 'Updated rule.'
      })

      setShowRuleModal(false)
    }
  }, [updateRuleState.success])

  return (
    <>
      <Container fluid className='mx-3'>
        <Alert
          className='table-body'
          show={alertState.show} 
          dismissible 
          onClose={() => setAlertState((ps) => ({ ...ps, show: false }))} 
          variant={alertState.variant}>
          {alertState.message}
        </Alert>
        {
          getRulesState.loading ? (
            <Row className='mt-2 table-body'>
              <Col xs={12} className='text-center'>
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                Loading...
              </Col>
            </Row>
          ) 
            : rules.map((rule) => (
              <Row className='mt-2 table-body' key={rule.opportunityId}>
                <Col xs={12}>
                  <h6>Opportunity Area: <span className='font-weight-bold'>{rule.name}</span></h6>
                </Col>
                <Col xs={12}>
                  {
                    rule.rules.map((r) => (
                      <Row key={r.ruleId} id='rule-row'>
                        <Col xs={6} className='border mb-2 p-2'>
                          <Row>
                            <Col xs={10}>
                              {r.description}
                            </Col>
                            <Col xs={2}>
                              <div className='custom-control custom-switch'>
                                <input
                                  type='checkbox'
                                  className='custom-control-input'
                                  id={r.description}
                                  name={r.description}
                                  checked={r.active}
                                  onChange={() => handleOpenRuleModal(rule, r)}
                                />
                                <label
                                  className='custom-control-label'
                                  htmlFor={r.description}
                                >
                                  {r.active ? 'Active' : 'Inactive'}
                                </label>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={5} className='border mb-2 p-2'>
                          <Row>
                            {
                              r.ruleActions.map((ruleAction) => (
                                <Col xs={12} key={ruleAction.action.actionId}>
                                  <Row className='mb-2'>
                                    <Col xs={8} className={`${!r.active ? 'text-muted' : ''}`}>
                                      {ruleAction.action.name}
                                    </Col>
                                    <Col xs={4}>
                                      <Button 
                                        variant={!r.active ? 'outline-primary' : 'outline-danger'}
                                        size='sm' 
                                        onClick={() => deleteRuleAction(rule.opportunityId, r.ruleId, ruleAction.actionId)}
                                        disabled={!r.active}
                                      >
                                        X
                                      </Button>
                                    </Col>
                                  </Row>
                                </Col>
                              ))
                            }
                            <Col xs={12}>
                              <Button size='sm' variant='outline-primary' onClick={() => handleOpenModal(rule, r)} disabled={!r.active}>
                                + Add
                              </Button>
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={1} className='border mb-2 p-2 text-center'>
                          {r.ruleId}
                        </Col>
                      </Row>
                    ))
                  }
                </Col>
              
              </Row>
            ))
        }
      </Container>
      <AddActionModal 
        show={showActionModal}
        onClose={handleCloseModal}
        rule={rule}
        actions={actions}
        onSubmit={handleSubmit}
        addRuleActionState={addRuleActionState}
      />
      <UpdateRuleModal
        show={showRuleModal}
        onClose={handleCloseRuleModal}
        rule={rule}
        onSubmit={handleSubmitUpdateRule}
        updateRuleState={updateRuleState}
      />
    </>
  )
}

Rules.propTypes = {
  rules: PropTypes.arrayOf(
    PropTypes.shape({
      opportunityId: PropTypes.number,
      name: PropTypes.string,
      rules: PropTypes.arrayOf(
        PropTypes.shape({
          ruleId: PropTypes.number,
          description: PropTypes.string,
          pocpId: PropTypes.string,
          active: PropTypes.number,
          ruleActions: PropTypes.arrayOf(
            PropTypes.shape({
              action: PropTypes.shape({
                actionId: PropTypes.number,
                name: PropTypes.string
              })
            })
          )
        })
      )
    })
  ),
  getRulesState: PropTypes.shape({
    loading: PropTypes.bool,
    success: PropTypes.bool,
    error: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.string,
      PropTypes.shape({
        message: PropTypes.string
      })
    ])
  }),
  addRuleAction: PropTypes.func,
  addRuleActionState: PropTypes.shape({
    loading: PropTypes.bool,
    success: PropTypes.bool,
    error: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.string,
      PropTypes.shape({
        message: PropTypes.string
      })
    ])
  }),
  deleteRuleAction: PropTypes.func,
  deleteRuleActionState: PropTypes.shape({
    loading: PropTypes.bool,
    success: PropTypes.bool,
    error: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.string,
      PropTypes.shape({
        message: PropTypes.string
      })
    ])
  }),
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      label: PropTypes.string,
      description: PropTypes.string
    })
  ),
  updateRule: PropTypes.func,
  updateRuleState: PropTypes.shape({
    loading: PropTypes.bool,
    success: PropTypes.bool,
    error: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.string,
      PropTypes.shape({
        message: PropTypes.string
      })
    ])
  }),
  reset: PropTypes.func
}

export default isAuthenticated(Rules)